<template>
  <div :class="`${$style.pageWrapper}`">
    <div :class="` ${$style.actRecords}`">
      <DropdownMenu style="">
        <DropdownItem v-model="gameId" :options="gameList"></DropdownItem>
      </DropdownMenu>
      <div
        v-for="(item, index) in receiveList"
        :class="` ${$style.content}`"
        :key="index"
      >
        <div :class="` ${$style.img}`">
          <img
            :src="`${cdnLink}/box_btWeekSignIn/${
              giftIconUrl[item.giftType]
            }.png`"
          />
        </div>
        <div :class="` ${$style.details}`">
          <h1>{{ item.giftName }}</h1>
          <p class="" style="">
            {{ item.giftDetail }}
          </p>
          <p :class="$style.time" style="color: #7682af">
            {{ item.receiveTime }}
          </p>
        </div>
        <Button
          v-if="item.cdk"
          :class="`${$style.nextStep} copySubscribeCdk`"
          @click="onCopy"
          :data-clipboard-text="item.cdk"
        >
          复制兑换码
        </Button>
        <Button
          v-else
          :class="`${$style.relationBtn}`"
          @click="onRelationServer"
        >
          联系客服
        </Button>
      </div>
      <div v-if="receiveList.length === 0" :class="$style.empty">
        <p>当前游戏暂无领取记录~</p>
        <p>可选择其他游戏查询</p>
      </div>
    </div>
  </div>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import Clipboard from "clipboard";
import { CDN_URL_1 } from "@/config";
import { onGoBack, setPageTitle } from "@/bridge/AppJsBridge";
import {
  getBtGIftRecordGamesApi,
  getBtWeekSignInGiftRecordApi,
} from "@/apis/btBoxActivity";
import { Button, DropdownMenu, DropdownItem } from "vant";
import { getCookie, pageLoseTips } from "@/libs/utils";

export default {
  name: "",
  components: {
    Button,
    DropdownMenu,
    DropdownItem,
  },
  data() {
    return {
      gameId: null,
      placeId: null,
      cdnLink: CDN_URL_1,
      pageTitle: "领取记录",
      giftInfo: null,
      cookie: null,
      isLoading: false,
      gameList: [],
      receiveList: [],
      giftIconUrl: { 1: "gift1", 3: "gift2", 5: "gift3", 7: "gift4" },
    };
  },
  computed: {},
  watch: {
    gameId: function (value, oldVal) {
      this.onChangeGameOption({ value });
    },
  },
  created() {
    // 页面初始化
    try {
      inithandler();
    } catch (error) {
      console.log(" error", error);
    }
    this.initPageData();
  },
  activated() {
    setPageTitle(this.pageTitle);
  },
  mounted() {
    this.copy = new Clipboard(".copySubscribeCdk");
  },
  methods: {
    // 获取cookie、缓存等携带的用户信息数据
    async initPageData() {
      setPageTitle(this.pageTitle);
      const { history } = this.$router;
      const { query } = history.current;
      if (query.gameId) {
        this.gameId = Number(query.gameId);
        this.placeId = query.placeId;
        this.getGameList(query.placeId);
      } else {
        pageLoseTips(this.$toast);
      }
    },

    // 联系客服
    onRelationServer() {
      this.$router.push({
        name: `box.customerService`,
      });
    },
    // 获取游戏列表
    async getGameList(placeId) {
      let data = await getBtGIftRecordGamesApi({placeId});
      this.gameList = [];
      data.data.map((item) => {
        let a = {
          text: "",
          value: "",
        };
        (a.text = item.appName), (a.value = item.gameId);
        this.gameList.push(a);
      });
    },

    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onChangeGameOption(props) {
      const { value } = props;
      if (value !== this.gameId) {
        this.$router.push({
          name: `box.btWeekSignInAct.record`,
          query: {
            gameId: value,
            placeId: this.placeId
          },
        });
      }
      getBtWeekSignInGiftRecordApi({ gameId: value }).then((res) => {
        this.receiveList = res.data;
      });
    },

    // 关闭页面
    closePage() {
      onGoBack();
    },
    onCopy() {
      this.copy.on("success", () => {
        this.$toast("复制成功");
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageWrapper {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  text-align: center;
  margin: auto;
  background: #f6f6f6;
  overflow: auto;
  .actRecords {
    background: #fff;
    width: 95%;
    min-height: 100vh;
    margin: 4px auto 0;
  }
  .empty {
    text-align: center;
    margin-top: 50px;
    color: #fc5f5e;
    line-height: 28px;
  }
  //   ::van-dropdown-menu__bar{

  //   }
  .content {
    margin: 10px 7px;
    padding: 6px;
    display: flex;
    justify-content: space-around;
    background: #f8fafd;
    border-radius: 8px;
    align-items: center;
    .img {
      width: 62px;
      height: 60px;
      background: #ebf2fc;
      border-radius: 13.54px;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 53px;
        //   height: 40px;
      }
    }
    .details {
      width: 150px;
      height: 60px;
      // background-color: blue;
    }
    .nextStep {
      height: 29px;
      line-height: 29px;
      border: none;
      background: #ffb017;
      color: #fff;
      font-size: 13px;
      text-align: center;
      border-radius: 13.33px;
    }
    .relationBtn {
      height: 29px;
      line-height: 29px;
      background: #f1f4fd;
      border: 0.69px solid #e3eaff;
      color: #6879ad;
      font-size: 13px;
      text-align: center;
      border-radius: 13.33px;
    }
    .time {
      height: 12px;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #6879ad;
    }
    .conversionCode {
      background-color: green;
      background: #fd383c;
    }
    h1 {
      height: 13.33px;
      font-size: 15px;
      font-family: Source Han Sans CN, Source Han Sans CN-Bold;
      font-weight: 700;
      text-align: left;
      color: #333333;
    }
    p {
      width: 150px;
      max-height: 24px;
      font-weight: 400;
      text-align: left;
      line-height: 12px;
      margin-top: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #999999;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    }
  }
}
</style>
